import { inject, Injectable } from '@angular/core';
import { NotificationSettings } from 'mbs-ui-shared@models';
import { NotificationOptionsService } from 'mbs-ui-shared@services/notification-options.service';
import { NotificationOptionsStore } from 'mbs-ui-shared@store/notificationOptions/notificationOptions';
import { Observable, tap } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class NotificationOptionsFacade {
  private readonly store = inject(NotificationOptionsStore);
  private readonly service = inject(NotificationOptionsService);

  public loading = this.store.loading;
  public loaded = this.store.loaded;
  public settings = this.store.settings;

  load(silent = false, force = false) {
    this.store.load({ silent, force });
  }

  save(settings: NotificationSettings): Observable<NotificationSettings> {
    return this.service.save(settings).pipe(tap(() => this.store.update(settings)));
  }
}
